export default class AccountTransfer {
  constructor() {
    this.activeTab = null;
    this.aggregatorInstitutions = [];
    this.confirmationDetails = {
      clientId: null,
      clientName: null,
      institutionName: null,
    };
  }
}
